// extracted by mini-css-extract-plugin
module.exports = {"content":"Breadcrumb__content___1x6Ug","item":"Breadcrumb__item___5w8gh"};